import { render, staticRenderFns } from "./FormSettings.vue?vue&type=template&id=cd0d5baa&scoped=true&"
import script from "./FormSettings.vue?vue&type=script&lang=js&"
export * from "./FormSettings.vue?vue&type=script&lang=js&"
import style0 from "./FormSettings.vue?vue&type=style&index=0&id=cd0d5baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0d5baa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd0d5baa')) {
      api.createRecord('cd0d5baa', component.options)
    } else {
      api.reload('cd0d5baa', component.options)
    }
    module.hot.accept("./FormSettings.vue?vue&type=template&id=cd0d5baa&scoped=true&", function () {
      api.rerender('cd0d5baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/pages/FormSettings.vue"
export default component.exports